// src/config/endpoints.js
export const ENDPOINTS = {
    GCP: {
        BASE_URL: 'https://us-central1-maia-tech.cloudfunctions.net',
        STORAGE_URL: 'https://storage.googleapis.com'
    },
    AZURE: {
        BASE_URL: 'https://maia-functions.azurewebsites.net/api'
    }
};

// Get URL for uploading files based on provider
export const getUploadUrl = (provider = 'GCP') => {
    const functionKey = process.env.REACT_APP_AZURE_FUNCTION_KEY;
    
    switch (provider.toUpperCase()) {
        case 'AZURE':
            if (!functionKey) {
                console.error('Azure function key is not configured');
                throw new Error('Azure function key is not configured');
            }
            return `${ENDPOINTS.AZURE.BASE_URL}/generateSignedUrl?code=${functionKey}`;
        case 'GCP':
        default:
            return `${ENDPOINTS.GCP.BASE_URL}/upload_file/generateSignedUrl`;
    }
};

// Get URL for supply matching endpoint based on provider
export const getSupplyMatchingUrl = (provider = 'GCP') => {
    const functionKey = process.env.REACT_APP_AZURE_FUNCTION_KEY;
    
    switch (provider.toUpperCase()) {
        case 'AZURE':
            if (!functionKey) {
                console.error('Azure function key is not configured');
                throw new Error('Azure function key is not configured');
            }
            return `${ENDPOINTS.AZURE.BASE_URL}/supply_matching?code=${functionKey}`;
        case 'GCP':
        default:
            return `${ENDPOINTS.GCP.BASE_URL}/supply_matching`;
    }
};

// Get URL for supply sources based on provider
export const getSupplySourcesUrl = (provider = 'GCP') => {
    const functionKey = process.env.REACT_APP_AZURE_FUNCTION_KEY;
    
    switch (provider.toUpperCase()) {
        case 'AZURE':
            if (!functionKey) {
                console.error('Azure function key is not configured');
                throw new Error('Azure function key is not configured');
            }
            return `${ENDPOINTS.AZURE.BASE_URL}/supply_sources?code=${functionKey}`;
        case 'GCP':
        default:
            return `${ENDPOINTS.GCP.BASE_URL}/supply_sources`;
    }
};